<script setup lang="ts">
import FormRow from "@/components/Common/FormRow.vue"
import createOrUpdateSubManagementOffice from "@/types/requests/createOrUpdateSubManagementOffice"
import { computed, defineProps, defineEmits } from 'vue';
import { Core as YubinBangoCore } from 'yubinbango-core2';
import i18n from '@/lang/i18n'

const props = defineProps<{
  modelValue: createOrUpdateSubManagementOffice
  errors: any
  windowInnerWidth: number
}>()

const emits = defineEmits(['update:modelValue'])

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

function autoCompleteAddress() {
  const zipCodeValue = `${modelValue.value.zip1}${modelValue.value.zip2}`;
  if (zipCodeValue.match(/^\d{3}-?\d{4}$/)) {
    return new YubinBangoCore(zipCodeValue, (addr: any) => {
      modelValue.value.province = addr.region;
      modelValue.value.address1 = addr.locality + addr.street;
    });
  }
  modelValue.value.province = ''
  modelValue.value.address1 = ''
  modelValue.value.address2 = ''
}
</script>
<template>
  <v-row class="text-form pl-4 pr-3 mb-3">
    <v-col :cols="windowInnerWidth > 800 ? 2 : 3">
      <h6 class="pl-4 align-center">
        {{ i18n.global.t('pages.subManagementOffice.form.zipCode') }}
      </h6>
    </v-col>
    <v-col cols="3">
      <v-text-field
        v-model="modelValue.zip1"
        maxlength="3"
        @keyup="autoCompleteAddress"
        :error-messages="errors?.zipcode"
      />
    </v-col>
    <span style="height: 50px; line-height: 50px"> - </span>
    <v-col cols="4">
      <v-text-field
        v-model="modelValue.zip2"
        maxlength="4"
        @keyup="autoCompleteAddress"
        :error="errors?.zipcode?.length"
      />
    </v-col>
  </v-row>
  <FormRow
    :title="i18n.global.t('pages.subManagementOffice.form.province')"
    :windowInnerWidth="props.windowInnerWidth"
  >
    <v-text-field
      v-model="modelValue.province"
      :error-messages="props.errors.province"
      maxlength="255"
    />
  </FormRow>
  <FormRow
    :title="i18n.global.t('pages.subManagementOffice.form.address1')"
    :windowInnerWidth="props.windowInnerWidth"
  >
    <v-text-field
      v-model="modelValue.address1"
      :error-messages="props.errors.address1"
      maxlength="255"
    />
  </FormRow>
  <FormRow
    :title="i18n.global.t('pages.subManagementOffice.form.address2')"
    :windowInnerWidth="props.windowInnerWidth"
  >
    <v-text-field
      v-model="modelValue.address2"
      :error-messages="props.errors.address2"
      maxlength="255"
    />
  </FormRow>
</template>